// extracted by mini-css-extract-plugin
export default {"centered":"styles-module__centered__src-labstep-web-screens-Onboarding-__o8_U"};